import {
  Bar,
  Label,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ComposedChart,
  Line,
  ResponsiveContainer
} from 'recharts';

import ChartWrapper from './ChartWrapper'

import {
  AQUA,
  COLORS, 
  convertToPercents,
  GREEN,
  LIGHT_BROWN,
  LIGHT_PURPLE,
  LIGHT_RED,
  PINK,
  tooltipFormatter,
  tooltipLabelFormatter,
  yaxisFormatter,
} from '../helpers'
import { useChartViewState } from '../hooks/useChartViewState';

const convertToPercentsHandler = (data) =>
  convertToPercents(data, {ignoreKeys: ['cumulative', 'movingAverageAll'], totalKey: 'all'})

export default function FeesChart(props) {
  const {
    data,
    loading,
    chartHeight,
    yaxisWidth,
  } = props

  const csvFields = [
    {key: 'position', name: 'Position'},
    {key: 'borrowing', name: 'Borrowing'},
    // {key: 'funding', name: 'Funding'},
    {key: 'swap', name: 'Swap'},
    {key: 'addLiquidity', name: 'AddLiquidity'},
    {key: 'removeLiquidity', name: 'RemoveLiquidity'},
    {key: 'liquidation', name: 'Liquidation'},
    {key: 'cumulative', name: 'Cumulative'}
  ]

  const controls = {
    convertToPercents: convertToPercentsHandler,
  }

  const {
    viewState,
    togglePercentView,
    formattedData,
    ...viewSettings
  } = useChartViewState({controls, data});

  return (
      <ChartWrapper 
        title="Fees"
        loading={loading}
        csvFields={csvFields}
        data={formattedData}
        controls={controls}
        viewState={viewState}
        togglePercentView={togglePercentView}
      >
        <ResponsiveContainer width="100%" height={chartHeight}>
          <ComposedChart data={formattedData} syncId="syncA">
            <CartesianGrid strokeDasharray="10 10" />
            <XAxis dataKey="timestamp" tickFormatter={tooltipLabelFormatter} minTickGap={30} />

            <YAxis 
              dataKey="all"
              interval="preserveStartEnd"
              tickCount={viewState.isPercentsView ? undefined : 7} 
              tickFormatter={viewSettings.yaxisTickFormatter}
              width={yaxisWidth} 
            />

            <YAxis dataKey="cumulative" orientation="right" yAxisId="right" tickFormatter={yaxisFormatter} width={yaxisWidth} />

            <Tooltip
              formatter={tooltipFormatter}
              labelFormatter={tooltipLabelFormatter}
              contentStyle={{ textAlign: 'left' }}
            />

            <Legend />
            <Bar unit={viewSettings.itemsUnit} isAnimationActive={false} type="monotone" dataKey="position" stackId="a" name="Position" fill={AQUA} />
            <Bar unit={viewSettings.itemsUnit} isAnimationActive={false} type="monotone" dataKey="borrowing" stackId="a" name="Borrowing" fill={GREEN} />
            {/* <Bar unit={viewSettings.itemsUnit} isAnimationActive={false} type="monotone" dataKey="funding" stackId="a" name="Funding" fill={COLORS[2]} /> */}
            <Bar unit={viewSettings.itemsUnit} isAnimationActive={false} type="monotone" dataKey="swap" stackId="a" name="Swap" fill={PINK} />
            <Bar unit={viewSettings.itemsUnit} isAnimationActive={false} type="monotone" dataKey="addLiquidity" stackId="a" name="AddLiquidity" fill={LIGHT_PURPLE} />
            <Bar unit={viewSettings.itemsUnit} isAnimationActive={false} type="monotone" dataKey="removeLiquidity" stackId="a" name="RemoveLiquidity" fill={LIGHT_BROWN} />
            <Bar unit={viewSettings.itemsUnit} isAnimationActive={false} type="monotone" dataKey="liquidation" stackId="a" name="Liquidation" fill={LIGHT_RED} />
            <Line isAnimationActive={false} type="monotone" strokeWidth={3} dot={false} stroke={COLORS[12]} dataKey="cumulative" yAxisId="right" name="Cumulative" />
          </ComposedChart>
        </ResponsiveContainer>
        <div className="chart-description">
          Collected fees. USD value is calculated with token price at the moment of swap, trade, minting or redeeming PLP
        </div>
      </ChartWrapper>
  )
}